import Vue from 'vue'
import RecommendShowModal from './RecommendShowModal.vue'
import RecommendMyPage from './RecommendMyPage.vue'
import SendPageAccess from './SendPageAccess.vue'

// 翻訳
import VueI18n from 'vue-i18n'
import Translate from './translation/Translate'

Vue.use(VueI18n)
const i18n = new VueI18n(Translate)
Vue.config.productionTip = false

if (document.getElementById('vue_rcmd_show_modal') !== null) {
  new Vue({
    i18n,
    render: (h) => h(RecommendShowModal)
  }).$mount('#vue_rcmd_show_modal')
}

if (document.getElementById('vue_rcmd_mypage') !== null) {
  new Vue({
    i18n,
    render: (h) => h(RecommendMyPage)
  }).$mount('#vue_rcmd_mypage')
}

if (document.getElementById('vue_rcmd_send_page_access') !== null) {
  new Vue({
    render: (h) => h(SendPageAccess)
  }).$mount('#vue_rcmd_send_page_access')
}
